export function humanize(str: string): string {

  try {
    return str
      .replace(/^[\s_]+|[\s_]+$/g, '')
      .replace(/[_\s]+/g, ' ')
      .replace(/^[a-z]/, (m) => m.toUpperCase());
  } catch (_error) {
    return str;
  }
}
